import React from "react";
// import { Link } from "react-router-dom";


export default function Categories() {
  return (
    <>
    
    </>
  );
}
